import script from "./page.vue?vue&type=script&setup=true&lang=ts"
export * from "./page.vue?vue&type=script&setup=true&lang=ts"

import "./page.vue?vue&type=style&index=0&id=72d5139a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d5139a"]])

export default __exports__